import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import MyApplication from './pages/MyApplication';
import AvailableJobs from './pages/AvailableJobs';
import Apply from './pages/Apply';
import Notfound from './pages/Notfound';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import Signin from './pages/Signin';
import Agreement from './pages/Agreement';
import Thankyou1 from './pages/Thankyou1';
import Thankyou2 from './pages/Thankyou2';
import Help from './pages/Help';
import Onboarding from './pages/Onboarding';
import Complete from './pages/OnboardingComponents/Complete';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminApplicantDetail from './pages/admin/AdminApplicantDetail';
import InterviewMediaUpload from './pages/InterviewMediaUpload';
import './css/style.scss';

import ProtectedRoute from './context/ProtectedRoute';
import AdminProtectedRoute from './context/AdminProtectedRoute';
import GoogleCallback from './context/GoogleCallback';
import ApplyRouteGuard from './context/ApplyRouteGuard';
import RegisterAndReset from './pages/RegisterAndReset';

function App() {
  const location = useLocation();

  useEffect(() => {
    document.querySelector('html').style.scrollBehavior = 'auto';
    window.scroll({ top: 0 });
    document.querySelector('html').style.scrollBehavior = '';
  }, [location.pathname]);

  return (
    <Routes>
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }>
        <Route path="my-application" element={<MyApplication />}>
          <Route path=":id" element={<MyApplication />} />
        </Route>
        <Route index element={<MyApplication />} />
        <Route path="available-jobs" element={<AvailableJobs />}>
          <Route path=":id" element={<AvailableJobs />} />
        </Route>
        <Route path="Agreement" element={<Agreement />} />
        <Route path="profile" element={<Profile />} />
        <Route path="thankyou1" element={<Thankyou1 />} />
        <Route path="thankyou2" element={<Thankyou2 />} />
        <Route
          path="/apply"
          element={
            <ApplyRouteGuard>
              <Apply />
            </ApplyRouteGuard>
          }
        />
        <Route path="onboarding" element={<Onboarding />} />
        <Route path="onboarding-complete" element={<Complete />} />
        <Route path="help" element={<Help />} />
        <Route path="*" element={<Notfound />} />
        <Route
          path="/interview-media-upload"
          element={<InterviewMediaUpload />}
        />
      </Route>
      <Route path="/handle-google-callback" element={<GoogleCallback />} />
      <Route path="/signin" element={<Signin />} />
      <Route path="/register" element={<RegisterAndReset />} />

      {/* Admin Routes */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route
        path="/admin/dashboard"
        element={
          <AdminProtectedRoute>
            <AdminDashboard />
          </AdminProtectedRoute>
        }
      />
      <Route
        path="/admin/applicant/:applicantId"
        element={
          <AdminProtectedRoute>
            <AdminApplicantDetail />
          </AdminProtectedRoute>
        }
      />
    </Routes>
  );
}

export default App;
